module.exports = __webpack_public_path__ + "files/27a33117c9e87996d618957adf3e9282.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-2.png
// module id = 501
// module chunks = 76